import { useState } from "react";
import { X, CalendarDays } from "lucide-react";
import { useLang } from "../../lib/lang";
import { useWeek } from "../../lib/hours";

const KEY = "lb-banner-dismissed";

export const useHolidayBanner = () => {
  const { lang } = useLang();
  const { upcoming } = useWeek();
  const sig = upcoming.map((s) => `${s.date}|${s.text}|${s.note || ""}`).join(";");
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY));
  const visible = upcoming.length > 0 && dismissed !== sig;
  const close = () => { localStorage.setItem(KEY, sig); setDismissed(sig); };
  const text = upcoming.map((s) => `${s.label}${s.note ? ` (${s.note})` : ""}: ${s.text}`).join("  ·  ");
  const title = lang === "sv" ? "Avvikande öppettider" : "Special opening hours";
  return { visible, close, text, title, closeLabel: lang === "sv" ? "Stäng" : "Close" };
};

export const BANNER_H = 36;

export const HolidayBanner = ({ banner }) => {
  if (!banner.visible) return null;
  const item = (
    <span className="flex shrink-0 items-center gap-3 px-8">
      <CalendarDays size={13} className="text-[#E9C46A]" />
      <span className="uppercase tracking-[0.2em] text-white/80">{banner.title}</span>
      <span className="font-medium text-[#E9C46A]">{banner.text}</span>
    </span>
  );
  return (
    <div data-testid="holiday-banner" style={{ height: BANNER_H }} className="fixed inset-x-0 top-0 z-[55] flex items-center overflow-hidden bg-[#4A0E17] text-xs">
      <div className="flex-1 overflow-hidden">
        <div className="banner-track flex w-max">
          {item}{item}{item}{item}
        </div>
      </div>
      <button data-testid="holiday-banner-close" onClick={banner.close} aria-label={banner.closeLabel} className="grid h-full w-10 shrink-0 place-items-center bg-[#4A0E17] text-white/80 transition-colors duration-300 hover:text-white">
        <X size={15} />
      </button>
    </div>
  );
};
